export const LANGUAGE_TAGS = [
  "en",
  "fi",
  "sv",
  "et",
  "lv",
  "lt",
  "pl",
  "de",
  "fr",
  "es",
  "it",
  "pt",
  "nl",
  "da",
  "no",
  "is",
  "ru",
  "uk",
  "be",
  "cs",
  "sk",
  "sl",
  "hu",
  "ro",
  "bg",
  "el",
  "tr",
  "ar",
  "he",
  "fa",
  "hi",
  "bn",
  "ur",
  "zh-Hans",
  "zh-Hant",
  "ja",
  "ko",
];
